import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { connect } from 'react-redux';

import * as Types from 'types';
import { fetchArtworkPreviewById } from 'features/media/actions';
import { ReactJWPlayer } from 'player/ReactJWPlayer';

type StateProps = {
  media?: Types.Media;
};

type DispatchProps = {
  fetchArtworkPreview: (artworkId: number) => void;
};

type OwnProps = {
  artworkId: number;
  initialize: boolean;
};

type Props = StateProps & DispatchProps & OwnProps;

class ArtworkPreviewPlayerComponent extends React.PureComponent<Props> {
  static defaultProps = {
    initialize: true,
  };

  player: jwplayer.JWPlayer | undefined;

  ref = React.createRef<HTMLDivElement>();
  componentId = uniqueId('react-jwplayer-');

  componentDidMount() {
    if (this.props.initialize && !this.props.media) {
      this.props.fetchArtworkPreview(this.props.artworkId);
    }
  }

  componentDidUpdate() {
    if (this.props.initialize && !this.props.media) {
      this.props.fetchArtworkPreview(this.props.artworkId);
    }
  }

  render() {
    const { media } = this.props;

    return <ReactJWPlayer url={media ? media.url : null} />;
  }
}

const mapStateToProps = (state: Types.RootState, props: OwnProps) => {
  return {
    media: state.media && state.media.previews[props.artworkId],
  };
};

const mapDispatchToProps = {
  fetchArtworkPreview: fetchArtworkPreviewById,
};

export const ArtworkPreviewPlayer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArtworkPreviewPlayerComponent);
